var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2.404 9.296 25.47-6.808 14.591 6.808v29.408l-25.447 6.808-14.614-6.808V9.296ZM0 40.192 16.826 48l28.043-7.504V7.808L28.043 0 0 7.504v32.688Zm31.488-20.584h4.087l3.365 9.008h-2.732l-.601-1.896h-4.119l-.6 1.896h-2.733l3.333-9.008Zm.625 5.192h2.869l-1.034-3.2h-.801l-1.034 3.2Zm-4.486-5.16-.802 2.168h-2.7v6.84h-2.652v-6.872h-2.932v-2.168l9.085.032Zm-18.429 0v5.28c0 1.328.673 1.824 2.003 1.824s1.995-.496 1.995-1.824v-5.28h2.628v5.088c0 2.968-1.65 4.152-4.623 4.152-2.972 0-4.63-1.184-4.63-4.152v-5.12l2.627.032Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ba2024c6218f32c0bd3771adc966a184.svg";
export { ForwardRef as ReactComponent };